export default {
  top: {
    enabled: false,
    shape: 'fadedSlant',
    height: 6,
    flip: false,
    color: 'hsla(0, 0%, 100%, 1)'
  },
  bottom: {
    enabled: false,
    shape: 'fadedSlant',
    height: 15,
    flip: false,
    color: 'hsla(0, 0%, 100%, 1)'
  }
}